import { useEffect, useRef } from "react";

/**
 * @param {Function} callback function to call when condition is met
 * @param {Boolean} isConditionSatisfied the condition to check
 * @param {Boolean} [triggerOnMountToo] (Default false) whether to conditionally call on mount too
 * @param {Boolean} [callOnlyOnce] (Default false) whether the callback should be called only once (ever). Usefull for initialization
 */
const useCallbackTriggerOnCondition = (
  callback,
  isConditionSatisfied,
  triggerOnMountToo = false,
  callOnlyOnce = false
) => {
  const ref = useRef({ isMount: true, called: false });
  const { isMount, called } = ref.current;
  const cb =
    (!callOnlyOnce || !called) &&
    (!isMount || triggerOnMountToo) &&
    isConditionSatisfied &&
    (callback || false);
  useEffect(() => {
    ref.current.isMount = false;
    if (cb) {
      ref.current.called = true;
      cb();
    }
  }, [cb]);
};

export default useCallbackTriggerOnCondition;
